import React, { createContext, useState, useContext } from 'react';

// Create the Loader Context
const LoaderContext = createContext();

// Custom hook to use loader state
export const useLoader = () => useContext(LoaderContext);

// Loader Provider component that wraps your app
export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(null);
  const [hasError, setHasError] = useState(false);

  return (
    <LoaderContext.Provider value={{ loading, loadingText,  setLoading, setLoadingText, hasError, setHasError }}>
      {children}
    </LoaderContext.Provider>
  );
};
